import React from 'react';
import { Auth } from 'aws-amplify';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import * as actions from '../../Redux/Actions/actions';

import * as MESSAGES from '../../Lib/Messages';
import Notification from '../UI_Library/Notification/Notification';
import InputError from '../UI_Library/FormElements/InputError';
import Validator from '../../Lib/Validator';
import Button from 'Components/UI_Library/FormElements/Button';
import classes from './Auth.module.css';
import MultilineNotification from 'Components/UI_Library/MultilineNotification';
import { withRouter } from 'Lib/withRouter';
import { changePassword } from 'Backend/users/useChangePassword';
import { isOktaExternalAuthToken } from 'Lib/Utils/authToken';

class UserChangePwd extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            errors: {},
            isError: false,
            errorMessage: '',
            successMessage: '',
            isShowPassword: false,
            isShowPasswordConfirm: false,
            showGuide: false,
        };

        this.state = { ...this.getInitialState(), ...this.state };
        const mss = this.props?.location?.state || {};
        if (mss.messages) {
            this.setState({
                errorMessage: mss.messages,
                isError: mss.isError || false,
            });
            const { pathname } = this.props.location;
            this.props.history(pathname, { replace: true });
        }
    }

    getInitialState = () => ({
        oldPassword: '',
        newPassword: '',
        confirmPassword: '',
    });

    componentDidMount() {
        this.props.actions.setMenuName('');
    }

    handleShowPassword = (flag) => {
        this.setState({ isShowPassword: flag });
    };

    handleShowPasswordConfirm = (flag) => {
        this.setState({ isShowPasswordConfirm: flag });
    };

    handleChange = (event) => {
        const {
            target: { name, value },
        } = event;
        const { errors } = this.state;
        if (errors[name]) {
            delete errors[name];
        }

        this.setState({
            [name]: value,
            errors,
        });
    };

    clearForm = () => {
        this.setState(this.getInitialState());
    };

    handleSave = async (e) => {
        const { oldPassword, newPassword } = this.state;
        e.stopPropagation();
        e.preventDefault();

        if (!this.isValidation()) {
            return false;
        }

        this.setState({ loading: true });

        if (isOktaExternalAuthToken()) {
            try {
                await changePassword({ oldPassword, newPassword });
                this.clearForm();
                this.setState({
                    successMessage: MESSAGES.SUCCESS_RESET_PASSWORD,
                    isError: false,
                });
            } catch (err) {
                const { detail } = err.response.data;
                if (detail === 'New password does not met password requirements') {
                    this.setState({ errorMessage: MESSAGES.ERROR_PASSWORD_INFO, isError: true });
                } else if (detail === 'Old password provided is not correct') {
                    this.setState({ errorMessage: MESSAGES.ERROR_PASSWORD_CORRECT, isError: true });
                } else if (detail === 'New password cannot be same as the old password') {
                    this.setState({ errorMessage: MESSAGES.ERROR_PASSWORD_NOT_UNIQUE, isError: true });
                } else {
                    this.setState({ errorMessage: MESSAGES.ERROR_CHANGE_PASSWORD, isError: true });
                }
            } finally {
                this.setState({
                    loading: false,
                });
            }
        } else {
            Auth.currentAuthenticatedUser()
                .then((user) => {
                    return Auth.changePassword(user, oldPassword, newPassword);
                })
                .then(() => {
                    this.setState({
                        loading: false,
                    });
                    this.clearForm();
                    this.setState({
                        successMessage: MESSAGES.SUCCESS_RESET_PASSWORD,
                    });
                })
                .catch((err) => {
                    if (err.message === 'Incorrect username or password.') {
                        this.setState({ errorMessage: MESSAGES.ERROR_PASSWORD_CORRECT, isError: true });
                    } else if (err.message) {
                        this.setState({ errorMessage: err.message, isError: true });
                    }

                    this.setState({ loading: false });
                });
        }
    };

    isValidation() {
        let errorMessage = '';
        this.setState({ errors: {}, errorMessage });

        const errors = {};
        let isError = false;
        const validator = new Validator();

        const { oldPassword, newPassword, confirmPassword } = this.state;

        if (!validator.required(oldPassword)) {
            errors.oldPassword = MESSAGES.ERROR_REQUIRED;
            isError = true;
        }

        if (!validator.required(newPassword)) {
            errors.newPassword = MESSAGES.ERROR_REQUIRED;
            isError = true;
        } else if (!validator.minLength(newPassword, 8)) {
            errors.newPassword = MESSAGES.ERROR_PASSWORD;
            errorMessage = MESSAGES.ERROR_PASSWORD_INFO;
            isError = true;
        } else if (!validator.validPassword(newPassword)) {
            errors.newPassword = MESSAGES.ERROR_PASSWORD;
            errorMessage = MESSAGES.ERROR_PASSWORD_INFO;
            isError = true;
        }

        if (!validator.required(confirmPassword)) {
            errors.confirmPassword = MESSAGES.ERROR_REQUIRED;
            isError = true;
        } else if (!validator.match(newPassword, confirmPassword)) {
            errors.confirmPassword = MESSAGES.ERROR_CONFIRM_PASS;
            isError = true;
        }

        if (isError) {
            this.setState({ errors, errorMessage, isError: true });
            return false;
        }

        return true;
    }

    render() {
        const {
            loading,
            errors,
            isError,
            errorMessage,
            successMessage,
            isShowPassword,
            isShowPasswordConfirm,
            oldPassword,
            newPassword,
            confirmPassword,
            showGuide,
        } = this.state;

        let buttonEnabled = oldPassword && newPassword && confirmPassword;
        return (
            <div className={classes.changePassword}>
                <div style={{ width: '100%' }}>
                    <Notification
                        isError={isError}
                        message={errorMessage || successMessage}
                        handleCloseMsg={() => {
                            this.setState({ errorMessage: '', successMessage: '' });
                        }}
                    />
                </div>
                <form method="POST">
                    <div className={`form-group${errors.oldPassword ? ' form-error' : ''}`}>
                        <label>Current password</label>
                        <input
                            type="password"
                            name="oldPassword"
                            className="form-control"
                            value={this.state.oldPassword}
                            onChange={this.handleChange}
                        />
                        <InputError error={errors.oldPassword} />
                    </div>
                    {showGuide && (
                        <MultilineNotification
                            messages={[
                                <strong style={{ width: '100%' }}>Your password will need:</strong>,
                                '- At least 8 characters',
                                '- A number',
                                '- A special character',
                                '- An uppercase letter',
                                '- A lowercase letter',
                            ]}
                            isBlue
                            handleCloseMsg={() => this.setState({ showGuide: false })}
                        />
                    )}
                    <div className={`form-group${errors.newPassword ? ' form-error' : ''}`}>
                        <div className={classes.labelWithSpan}>
                            <label>New password</label>
                            <span onClick={() => this.setState({ showGuide: true })}>
                                {showGuide ? 'Hide ' : 'Show '}password requirements
                            </span>
                        </div>
                        <input
                            type={isShowPassword ? 'text' : 'password'}
                            name="newPassword"
                            className="form-control"
                            value={this.state.newPassword}
                            onChange={this.handleChange}
                        />
                        <i
                            className={`i-${isShowPassword ? 'unview' : 'view'}`}
                            onClick={() => this.handleShowPassword(!isShowPassword)}
                        />
                        <InputError error={errors.newPassword} />
                    </div>

                    <div className={`form-group${errors.confirmPassword ? ' form-error' : ''}`}>
                        <label>Confirm password</label>
                        <input
                            type={isShowPasswordConfirm ? 'text' : 'password'}
                            name="confirmPassword"
                            className="form-control"
                            value={this.state.confirmPassword}
                            onChange={this.handleChange}
                        />
                        <i
                            className={`i-${isShowPasswordConfirm ? 'unview' : 'view'}`}
                            onClick={() => this.handleShowPasswordConfirm(!isShowPasswordConfirm)}
                        />
                        <InputError error={errors.confirmPassword} />
                    </div>
                </form>
                <div className={classes.spacer} />
                <Button
                    type="primary"
                    text="Confirm"
                    onClick={this.handleSave}
                    disabled={!buttonEnabled || loading}
                    loading={loading}
                    loaderType="in-button blue"
                />
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        page: state.page,
    };
};

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(actions, dispatch),
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(UserChangePwd));
